module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add an prompt","submit":"Save"}}')
  delete Component.options._Ctor
}
